import { useEffect, useState } from 'react';
import apis from '@src/apis';

/**
 * The caption font catalogue from `GET /fonts`.
 *
 * The menu, the style cards and the preview all need it, so the promise is held
 * at module level and they join the one request. Seven documents that change
 * only on a reseed, so once per session is enough.
 */
let pending = null;

const fetchCatalog = () => {
  if (pending) return pending;
  pending = apis.font
    .getFonts()
    .then((response) => {
      const fonts = response?.result?.fonts || [];
      // Empty means the catalogue is not seeded yet, not an answer worth
      // keeping: cached, the menu stays empty all session. The API guards this.
      if (!fonts.length) pending = null;
      return fonts;
    })
    // A failure must not stick either — the next mount retries.
    .catch(() => {
      pending = null;
      return [];
    });
  return pending;
};

const useFontCatalog = () => {
  const [fonts, setFonts] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetchCatalog().then((list) => {
      if (!cancelled) setFonts(list);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return fonts;
};

export default useFontCatalog;
